<script>


export default {
    props: {
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
<template>
  <button class="btn btn-xs">
    <icon-edit width="12" height="16" />
  </button>
</template>